import { Input } from 'govwell-ui'
import { T } from 'govwell-ui'

import { formatPhoneInput, parsePhoneDigits } from 'src/utils'
import { TanstackField } from 'src/utils/forms'

type Props<TKey extends string> = {
  field: TanstackField<string, TKey>
  isRequired?: boolean
  label?: React.ReactNode
}

const COUNTRY_CODE_ADDON = <T.Body>+1</T.Body>

const PhoneInputField = <TKey extends string>({ field, isRequired, label }: Props<TKey>) => {
  const errorMessage = field.state.meta.errors.join(', ')

  return (
    <Input
      label={label ?? 'Phone Number'}
      value={formatPhoneInput(field.state.value)}
      onValueChange={(value) => field.handleChange(parsePhoneDigits(value ?? ''))}
      onBlur={field.handleBlur}
      placeholder="(555) 555-5555"
      leftAddon={COUNTRY_CODE_ADDON}
      errorMessage={errorMessage}
      isInvalid={!!errorMessage}
      isRequired={isRequired}
    />
  )
}

export default PhoneInputField
